<div class="sip-info-section" [class.v1]="config.v1">
  <div *ngIf="!hideHeadBanner">
    <div class="heading">You have impacted <span>{{summary?.funds}} {{summary?.funds>1 ? 'lives' : 'life'}}</span></div>
    <div class="banner"><img loading="lazy" [attr.data-src]="'/assets/images/kids-enjoy.png'" /></div>
    <div class="middle-heading">Continue with <span>Monthly Giving</span></div>
    <div *ngIf="config?.backOffer" class="bottom-heading">And Build A Fund For Yourself</div>
    <div *ngIf="config?.v1" class="new-bottom-heading">And *Create A Bigger Impact*</div>
  </div>

  <div *ngIf="!hideInfo" class="info">
    <div class="info-icon">
      <img loading="lazy" [attr.data-src]="'/assets/images/money-hand.png'" />
      <div>A giving program that transforms critical lives every month</div>
    </div>
    <div class="info-icon">
      <img loading="lazy" [attr.data-src]="'/assets/images/bank.png'" />
      <div>Join and create impact with as little as INR 100 every month</div>
    </div>
    <div class="info-icon">
      <img loading="lazy" [attr.data-src]="'/assets/images/note-1.png'" />
      <div>Direct your funds to a campaign of your choice with ease</div>
    </div>
  </div>

</div>